import React, { useState } from 'react';
import { Box, Button, Grid, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { useSnackbar } from 'notistack';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../configs/messages';
import showMessage from '../../../helpers/showMessage';
import { sendFormData } from '../../../helpers/sendFormData';

export default function EpgPosterUpload({ selectedChannel }) {
    const { enqueueSnackbar } = useSnackbar();
    const [initialData, setInitialData] = useState({
        imageUrl: '',
        image: null,
    });
    const [openDialog, setOpenDialog] = useState(false);

    const handleImageInsert = (e) => {
        const uploadedFiles = e.target.files;

        if (uploadedFiles && uploadedFiles.length > 0 && uploadedFiles[0].size > 2097152) {
            showMessage(ERROR_MESSAGES.FILE_SIZE_TOO_BIG, enqueueSnackbar, 'error');
            setInitialData({
                ...initialData,
                image: null,
                imageUrl: '',
            });
        } else if (uploadedFiles && uploadedFiles.length > 0) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setInitialData({
                    ...initialData,
                    image: uploadedFiles[0],
                    imageUrl: reader.result,
                });
            };

            reader.readAsDataURL(uploadedFiles[0]);
        }
    };

    const handleSubmit = async () => {
        if (!initialData.image) {
            showMessage(ERROR_MESSAGES.NO_FILE_SELECTED, enqueueSnackbar, 'error');
            return;
        }
    
        const requestBody = { poster: initialData.image };
        try {
            await sendFormData(requestBody, `poster/${selectedChannel.id}/${selectedChannel.name}`);
            showMessage(SUCCESS_MESSAGES.ADDED_POSTER, enqueueSnackbar);
            
            setInitialData({
                imageUrl: '',
                image: null,
            });
    
            document.querySelector('input[type="file"]').value = '';
        } catch (error) {
            console.error('Error submitting data:', error);
            showMessage(
                error.response?.data?.message || ERROR_MESSAGES.REQUEST_FAIL,
                enqueueSnackbar,
                'error',
            );
        } finally {
            setOpenDialog(false); 
        }
    };
    

    const handleDialogOpen = (e) => {
        e.preventDefault();
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
    };

    return (
        <Box>
            <form onSubmit={handleDialogOpen} autoComplete="off">
                <Grid container direction="column" gap="20px">
                    <div>
                        {initialData.imageUrl && (
                            <img
                                src={initialData.imageUrl}
                                alt="зураг"
                                style={{
                                    height: '300px',
                                    width: '400px',
                                    objectFit: 'cover',
                                }}
                            />
                        )}
                    </div>
                    <div>
                        <p style={{ fontSize: '12px' }}>
                            Зургийн харьцаа 4:3 (800x600), зургийн хэмжээ дээд 2MB
                        </p>
                        <Button variant="contained" component="label">
                            Poster зураг оруулах
                            <input
                                hidden
                                accept="image/*"
                                type="file"
                                onChange={handleImageInsert}
                            />
                        </Button>
                    </div>
                </Grid>
                <Box>
                    <Grid item>
                        <Button
                            color="success"
                            style={{ marginTop: '10px' }}
                            type="submit"
                            variant="outlined"
                        >
                            <SaveAltIcon />
                            <Typography style={{ marginLeft: '10px' }}>
                                Хадгалах
                            </Typography>
                        </Button>
                    </Grid>
                </Box>
            </form>

            <Dialog open={openDialog} onClose={handleDialogClose}>
                <DialogTitle>Баталгаажуулах</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Та энэ постер зургийг хадгалахдаа итгэлтэй байна уу?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="error">
                        Үгүй
                    </Button>
                    <Button onClick={handleSubmit} color="success">
                        Тийм
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
